import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download } from "lucide-react";

export function QRCodeBox({ value, fileName = "qr-noumabou", size = 180, caption }) {
  const wrapRef = useRef(null);

  const download = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.png`;
    a.click();
  };

  return (
    <div className="flex flex-col items-center gap-3" data-testid="qr-box">
      <div ref={wrapRef} className="bg-white p-3 rounded-2xl border border-brand-line">
        <QRCodeCanvas value={value} size={size} level="M" includeMargin fgColor="#3b2260" />
      </div>
      {caption && <p className="text-xs text-brand-muted text-center max-w-[220px] break-all">{caption}</p>}
      <button onClick={download} data-testid="qr-download" className="flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white" style={{ background: "#5B2A9D" }}>
        <Download className="w-4 h-4" /> Télécharger le QR code
      </button>
    </div>
  );
}
